import { Tab, Tabs } from '@trackman/web-shared-components';
import Box from '@mui/material/Box/Box';
import { ParameterCategoryView } from 'types/trackmanParameters';

type CategoriesTabsProps = {
  categories: ParameterCategoryView[];
  selectedCategoryId: string | undefined;
  onCategorySelected: (categoryId: string) => void;
};

export const CategoriesTabs = ({ categories, selectedCategoryId, onCategorySelected }: CategoriesTabsProps) => {
  const selectedTabIndex = Math.max(
    categories.findIndex((category) => category.id === selectedCategoryId),
    0
  );

  return (
    <Box className='tabs-container'>
      <Tabs
        scrollButtons='auto'
        variant='scrollable'
        indicatorColor='primary'
        allowScrollButtonsMobile
        value={selectedTabIndex}
        onChange={(_, newIndex: number) => onCategorySelected(categories[newIndex].id)}
      >
        {categories.map((category) => (
          <Tab label={category.title} key={category.id}></Tab>
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoriesTabs;
